import { styled } from "@mui/material";
import Box from "@mui/material/Box";

export const PaddedRow = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2, 0),
}));
